import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StoreAccessoryRequestCreate, StoreAccessoryRequestList, StoreAccessoryRequestPublished, StoreAccessoryRequestSearch, StoreAccessoryRequestUpdate } from '../../../models/api-store/store-accessory/store-accessory.request.model';
import { StoreAccessoryResponseCreate, StoreAccessoryResponseGet, StoreAccessoryResponseList, StoreAccessoryResponsePublish, StoreAccessoryResponseSearch, StoreAccessoryResponseUpdate } from '../../../models/api-store/store-accessory/store-accessory.response.model';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StoreAccessoryService {

  constructor(private http: HttpClient) { }
  pathUrl: string = environment.backend.pathUrl.store.store_accessory;
  baseUrl: string = environment.backend.baseUrl_backend;
  url: string = this.baseUrl + this.pathUrl;

  /**createParams
       * @param objectStoresParams 
       * @returns params
       * Prende in input un oggetto e lo trasforma in un HttpParams
       */
   createParams(objectStoresParams: any) {
    let params = new HttpParams();
    for (let property in objectStoresParams) {
      if (objectStoresParams.hasOwnProperty(property)) {
        params = params.append(property, objectStoresParams[property]);
      }
    }
    return params;
  }


  getList(request:StoreAccessoryRequestList):Observable<StoreAccessoryResponseList>{
    let url = this.url;
    let params = this.createParams(request);
    return this.http.get<StoreAccessoryResponseList>(url,{ params: params });
  }



  create(request: StoreAccessoryRequestCreate): Observable<StoreAccessoryResponseCreate> {
    let url = this.url+"/";
    return this.http.post<StoreAccessoryResponseCreate>(url, request);
  }

  getEntity(id: number): Observable<StoreAccessoryResponseGet> {
    let url = this.url + "/" + id;
    return this.http.get<StoreAccessoryResponseGet>(url);
  }

  update(id: number, request: StoreAccessoryRequestUpdate): Observable<StoreAccessoryResponseUpdate> {
    let url = this.url + "/" + id;
    return this.http.put<StoreAccessoryResponseUpdate>(url, request);
  }

  delete(id: number) {
    let url = this.url + "/" + id;
    return this.http.delete<any>(url);
  }

  publish(id:number,published:boolean):Observable<StoreAccessoryResponsePublish>{
    let url = this.url+"/"+id+"/publish?published="+published;
    let request = new StoreAccessoryRequestPublished();
    request.id = id;
    request.published = published;
    return this.http.put<StoreAccessoryResponsePublish>(url,request);
  }

  search(request:StoreAccessoryRequestSearch):Observable<StoreAccessoryResponseSearch>{
    let url = this.url+"/search";
    return this.http.post<StoreAccessoryResponseSearch>(url,request);
  }

}
